class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.searchRequestController = null;
    this.searchRequestId = 0;
    this.searchPageController = null;
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.clearButton = this.querySelector('[data-search-clear-sidebar]');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.isOpen = false;
    this.quickSearchTrending = this.querySelectorAll('.quickSearchTrending .link');
    this.searchResultsWidget = this.getElementsByClassName('quickSearchResultsWidget')[0];

    this.setupEventListeners();
    if (this.contains(document.activeElement) && this.getQuery()) this.onChange();
    this.quickSearchTrending.forEach(element => {
      element.addEventListener('click', this.quickSearchTrendingClick.bind(this));
    });
  }
  
  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    
    this.input.addEventListener('input', this.onChange.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    if (this.clearButton) {
      const syncClearButton = () => {
        this.clearButton.hidden = this.input.value.length === 0;
      };

      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.focus();
      });
      this.input.addEventListener('input', syncClearButton);
      syncClearButton();
    }
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('click', this.onDocClick.bind(this));
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
    this.input.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
    if(window.innerWidth <= 1024){
        if(document.querySelector('[data-search-mobile]')){
            document.querySelectorAll('[data-search-mobile]').forEach((button) => {
                button.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
            });
        }
    }
  }

  doBeforeQuickSearchProduct(){
    this.renderQuickSearchProductBlock();
  }

  renderQuickSearchProductBlock(){
    if (!this.searchResultsWidget) return;

    if(!this.searchResultsWidget.classList.contains('ajax-loaded')){
      const block = this.searchResultsWidget.querySelector('.quickSearchProduct');

      let url = block?.getAttribute('data-collection'),
          limit = block?.getAttribute('data-limit'),
          sectionId = 'list-result-block';

      if(url != null && url != undefined) {
          $.ajax({
              type: 'GET',
              url: window.routes.root + '/collections/' + url,
              cache: false,
              data: {
                  view: 'ajax_product_block',
                  constraint: `limit=${limit}+sectionId=${sectionId}`
              },
              beforeSend: () => {
                  block.closest('.quickSearchResultsWidget').classList.add('ajax-loaded');
              },
              success: (data) => {
                  if (url != '') {
                      const dataRes = this.handleResponse(data, limit);
                      block.querySelector('.products-grid').innerHTML = dataRes;
                  }
                  window.sharedFunctions?.swapHoverVideoProductCard();
              },
              complete: () => {
                  if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
                      let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                      Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                  }
              }
          });
      } else{
          this.searchResultsWidget.classList.add('ajax-loaded');
          if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
              let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
              Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
      }
    }
  }

  handleResponse(data,limit) {
    let htmlMedia = document.createElement('div');
    htmlMedia.innerHTML = data;

    $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();
    return $(htmlMedia).html();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) return this.showTrendingAndProducts();

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    this.scheduleFocusOutClose();
  }

  onPointerEnter() {
    window.clearTimeout(this.focusOutTimer);
  }

  onPointerLeave() {
    if (!this.contains(document.activeElement)) this.scheduleFocusOutClose();
  }

  scheduleFocusOutClose() {
    window.clearTimeout(this.focusOutTimer);
    this.focusOutTimer = window.setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.matches(':hover')) {
        this.close();
      }
    }, 700);
  }
  
  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';
    
    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }
  
  cancelPendingSearchRequest() {
    this.searchRequestId += 1;
    this.searchRequestController?.abort();
    this.searchPageController?.abort();
    this.searchPageController = null;
    this.searchRequestController = null;
    this.removeAttribute('loading');
  }

  getSearchResults(searchTerm) {
    const searchQuery = dmSearchQuery(searchTerm);
    const queryKey = searchQuery.replace(/\s+/g, '-').toLowerCase();

    this.cancelPendingSearchRequest();
    const requestId = this.searchRequestId;

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.updateViewAllLink(searchTerm);
      return;
    }

    this.setLiveRegionLoadingState();
    this.searchRequestController = new AbortController();

    fetch(`${routes.search_url}?q=${encodeURIComponent(searchQuery)}&type=product&options%5Bprefix%5D=last&section_id=predictive-search`, {
      signal: this.searchRequestController.signal
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);

        return response.text();
      })
      .then((text) => {
        if (requestId !== this.searchRequestId || searchTerm !== this.getQuery()) return;

        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Predictive search response is missing its section');

        const resultsMarkup = section.innerHTML;
        this.renderSearchResults(resultsMarkup);
        this.cachedResults[queryKey] = resultsMarkup;
        this.updateViewAllLink(searchTerm);
      })
      .catch((error) => {
        if (error.name === 'AbortError' || requestId !== this.searchRequestId) return;

        this.close();
        this.removeAttribute('results');
        this.predictiveSearchResults.innerHTML = '';
        this.setLiveRegionText('');
        console.error(error);
      })
      .finally(() => {
        if (requestId === this.searchRequestId) this.searchRequestController = null;
      });
  }
  
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    const responseDocument = new DOMParser().parseFromString(resultsMarkup, 'text/html');
    const resultsPanel = responseDocument.querySelector('#predictive-search-results');
    const resultsCount = resultsPanel?.querySelector('[data-predictive-search-live-region-count-value]');
    if (!resultsCount) throw new Error('Search response is missing its results panel or count');

    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.predictiveSearchResults.scrollTop = 0;
    this.predictiveSearchResults.querySelectorAll('.quickSearchResults').forEach((results) => {
      results.scrollTop = 0;
    });
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
    this.setupProductSlider();
    if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
      Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
  }

  setupProductSlider() {
    const slider = this.querySelector('[data-predictive-products-slider]');
    const controls = this.querySelector('[data-predictive-slider-controls]');
    const results = slider?.closest('[data-search-next-url]');
    if (!slider || !controls || !results) return;

    const previous = controls.querySelector('.dm-mobile-snap-arrow--prev');
    const next = controls.querySelector('.dm-mobile-snap-arrow--next');
    const searchTerm = this.getQuery();
    let pageLoading = false;
    const isCurrent = () => this.isOpen
      && searchTerm === this.getQuery()
      && slider === this.querySelector('[data-predictive-products-slider]');
    const getStep = () => {
      const firstProduct = slider.querySelector(':scope > .product');
      if (!firstProduct) return slider.clientWidth;

      const styles = window.getComputedStyle(slider);
      return firstProduct.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
    };
    const maxScroll = () => Math.max(0, slider.scrollWidth - slider.clientWidth);
    const updateControls = () => {
      previous.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft >= maxScroll() - 2 && !results.dataset.searchNextUrl;
    };
    const loadNextPage = async () => {
      if (pageLoading || !results.dataset.searchNextUrl || !isCurrent()) return false;

      const requestId = this.searchRequestId;
      pageLoading = true;
      controls.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      this.searchPageController = controller;
      try {
        const url = new URL(results.dataset.searchNextUrl, window.location.origin);
        url.searchParams.set('section_id', 'predictive-search');
        const response = await fetch(url.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(response.status);

        const text = await response.text();
        if (controller.signal.aborted || requestId !== this.searchRequestId || !isCurrent()) return false;

        const document = new DOMParser().parseFromString(text, 'text/html');
        const page = document.querySelector('#shopify-section-predictive-search [data-search-next-url]');
        const products = page?.querySelectorAll('[data-predictive-products-slider] > .product');
        if (!page || !products?.length) throw new Error('Search page is missing its products');

        products.forEach((product) => product.classList.remove('scroll-trigger', 'animate--slide-in'));
        slider.append(...products);
        results.dataset.searchNextUrl = page.dataset.searchNextUrl || '';
        if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
          Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
        window.sharedFunctions?.swapHoverVideoProductCard();
        return true;
      } catch (error) {
        if (error.name !== 'AbortError' && isCurrent()) console.error(error);
        return false;
      } finally {
        pageLoading = false;
        controls.removeAttribute('aria-busy');
        if (this.searchPageController === controller) this.searchPageController = null;
        if (isCurrent()) updateControls();
      }
    };
    const move = async (direction) => {
      if (direction > 0 && slider.scrollLeft >= maxScroll() - 2 && results.dataset.searchNextUrl) {
        if (!await loadNextPage() || !isCurrent()) return;
      }
      slider.scrollBy({ left: direction * getStep(), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    slider.addEventListener('scroll', updateControls, { passive: true });
    requestAnimationFrame(updateControls);
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('[class^="header-navigation"]').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  
  open() {
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.cancelPendingSearchRequest();

    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    if (this.input.getAttribute('aria-activedescendant') !== '') {
      this.input.setAttribute('aria-activedescendant', '');
    }
    this.removeAttribute('open');
    if (this.input.getAttribute('aria-expanded') !== 'false') {
      this.input.setAttribute('aria-expanded', false);
    }
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  updateViewAllLink(searchTerm) {
    const qsViewAllLink = this.querySelector('[data-qs-view-all-link]');
    if (!qsViewAllLink) return;

    qsViewAllLink.href = `${routes.search_url}?q=${encodeURIComponent(dmSearchQuery(searchTerm))}&options%5Bprefix%5D=last&type=product`;
  }

  quickSearchTrendingClick(event) {
    window.location = event.currentTarget.getAttribute('href');
  }
}

customElements.define('predictive-search', PredictiveSearch);
(() => {
    const SEARCH_TRANSITION_DELAY = 450;
    let activeSearch = null;
    let focusTimer = null;

    const desktopContext = (trigger = document.querySelector('[data-search-menu]')) => {
        const details = trigger?.closest('details');
        const container = details?.querySelector('[role="dialog"]');

        if (!trigger || !details || !container) return null;

        return {
            type: 'desktop',
            trigger,
            details,
            container,
            initialFocus: container.querySelector('.header-search-close') || container.querySelector('input[type="search"]')
        };
    };

    const mobileContext = (trigger = document.querySelector('summary[data-search-mobile]')) => {
        const container = document.querySelector('.halo-sidebar_search');

        if (!trigger || !container) return null;

        return {
            type: 'mobile',
            trigger,
            container,
            initialFocus: container.querySelector('[data-search-close-sidebar]') || container.querySelector('input[type="search"]')
        };
    };

    const isOpen = (context) => {
        if (!context) return false;

        if (context.type === 'desktop') {
            const { width, height } = context.container.getBoundingClientRect();

            return context.details.hasAttribute('open')
                && context.container.getClientRects().length > 0
                && width > 0
                && height > 0;
        }

        return document.body.classList.contains('open_search_mobile');
    };

    const activate = (context) => {
        if (!context) return;

        activeSearch = context;
        window.clearTimeout(focusTimer);
        focusTimer = window.setTimeout(() => {
            if (!isOpen(context)) return;

            const hiddenButtons = Array.from(context.container.querySelectorAll('button:enabled'))
                .filter((button) => button.getClientRects().length === 0);

            hiddenButtons.forEach((button) => button.disabled = true);
            trapFocus(context.container, context.initialFocus);
            hiddenButtons.forEach((button) => button.disabled = false);
        }, SEARCH_TRANSITION_DELAY);
    };

    const close = (context = activeSearch) => {
        if (!context) return;

        window.clearTimeout(focusTimer);
        document.body.classList.remove('open_search_menu', 'open_search_mobile');
        context.details?.removeAttribute('open');
        removeTrapFocus(context.trigger);
        activeSearch = null;
    };

    const initialize = () => {
        document.addEventListener('click', (event) => {
            const desktopTrigger = event.target.closest('[data-search-menu]');
            const mobileTrigger = event.target.closest('summary[data-search-mobile]');
            const desktopClose = event.target.closest('.header-search-close');
            const mobileClose = event.target.closest('[data-search-close-sidebar]');

            if (desktopClose || mobileClose) {
                event.preventDefault();
                close(activeSearch || (desktopClose ? desktopContext() : mobileContext()));
                return;
            }

            if (desktopTrigger || mobileTrigger) {
                window.setTimeout(() => {
                    activate(desktopTrigger ? desktopContext(desktopTrigger) : mobileContext(mobileTrigger));
                });
            }
        }, true);

        document.addEventListener('keydown', (event) => {
            const desktopTrigger = event.target.closest?.('[data-search-menu]');

            if (desktopTrigger && event.key === 'Enter') {
                event.preventDefault();
                const context = desktopContext(desktopTrigger);

                document.body.classList.add('open_search_menu');
                context?.details.setAttribute('open', '');
                activate(context);
                return;
            }

            if (event.key !== 'Escape') return;

            const context = activeSearch
                || (document.body.classList.contains('open_search_mobile') ? mobileContext() : null)
                || (document.querySelector('[data-search-menu]')?.closest('details')?.hasAttribute('open') ? desktopContext() : null);

            if (!isOpen(context)) return;

            event.preventDefault();
            event.stopPropagation();
            close(context);
        }, true);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
})();
